import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Card": Card, "@mui/material/CardContent": CardContent, "@mui/material/CardMedia": CardMedia, "@mui/material/Typography": Typography, "@mui/material/Button": Button, "@mui/material/CardActionArea": CardActionArea, "@mui/material/CardActions": CardActions } } });
export default ClientProvider;
